/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */
import Axes from "./Axes";
export { PanInput } from "./inputType/PanInput";
export { RotatePanInput } from "./inputType/RotatePanInput";
export { PinchInput } from "./inputType/PinchInput";
export { WheelInput } from "./inputType/WheelInput";
export { MoveKeyInput } from "./inputType/MoveKeyInput";

export default Axes;

export { AXES_METHODS, AXES_EVENTS } from "./const";
export * from "./types";
export * from "./reactive";
